import React from 'react';
import '../../ui/popups/Popup/BasePopup/index.js';
import '../../ui/popups/Popup/Thumb/index.js';
import { ThumbV2 } from '../../ui/popups/Popup/ThumbV2/index.js';
import '../../ui/popups/Popup/InfoTooltip/index.js';
import { Select } from '../Select/index.js';

const SelectV4 = ({
  options,
  isMultiple,
  onSelect,
  formType,
  selectedIds = [],
  text = {
    thumbLabel: "",
    placeholder: "All"
  },
  className,
  style,
  ...props
}) => /* @__PURE__ */ React.createElement("div", { className, style, ...props }, /* @__PURE__ */ React.createElement(
  Select,
  {
    ...props,
    options,
    onSelect,
    hasSearch: true,
    popupStyle: { width: 240 },
    version: "v3",
    isMultiple,
    selectedIds,
    renderThumb: (thumbProps) => /* @__PURE__ */ React.createElement(
      ThumbV2,
      {
        ...thumbProps,
        image: thumbProps.image,
        formType,
        thumbLabel: text.thumbLabel
      }
    ),
    placeholder: text.placeholder,
    hasThumbText: true,
    horizontalAlignment: "auto",
    popupGap: 8,
    theme: "blue",
    clearChildrenWrapper: true,
    optionsBorderTop: true,
    popupClassName: "selectV4-popup"
  }
));
SelectV4.displayName = "SelectV4";

export { SelectV4 };
//# sourceMappingURL=index.js.map
